import Dexie, { EntityTable, Table } from 'dexie'
import { injectable } from 'inversify'

import {
  DexieDefaultWeight,
  DexieUserGeometry,
  DexieUserGeometryFile,
  DexieWBAirplaneFill,
  DexieWBProfile
} from './IDexieDB'

/**
 * @todo Sempre que precisar mudar o esquema (criar/alterar tabelas), é necessário incrementar a versão.
 */
@injectable()
export class DexieDB extends Dexie {
  defaultWeights: EntityTable<DexieDefaultWeight, 'id'>
  wbProfiles: EntityTable<DexieWBProfile, 'id'>
  wbAirplaneFills: EntityTable<DexieWBAirplaneFill, 'id'>
  userGeometries: Table<DexieUserGeometry, string>
  userGeometryFiles: Table<DexieUserGeometryFile, [string, string]>

  constructor() {
    super('PlanningAppLocalDB')
    this.version(5).stores({
      defaultWeights: '++id, name, weight, unit, station, createdAt, updatedAt', // Primary key and indexed props
      wbProfiles:
        '++id, aircraftId, wbProfileAirplaneModelId, name, reference, weightUnit, armUnit, fuelQuantityUnit, momentIndex, basicEmptyWeight, basicEmptyWeightArm, maximumTakeoffWeight, maximumZeroFuelWeight, maximumRampWeight, maximumLandingWeight, stations, envelope, createdAt, updatedAt',
      wbAirplaneFills:
        '++id, aircraftId, wBProfileAirplaneId, name, departure, arrival, departureTime, pilotName, pilotCode, remark, taxiFuel, flightFuel, stationsFill, createdAt, updatedAt'
    })
    // v6: user geometries (KML/KMZ). Metadata + blob tables added additively;
    // existing v5 tables are carried over by Dexie. The `user_geometry_files`
    // blob store uses the compound primary key `[id+kind]`.
    this.version(6).stores({
      userGeometries: 'id, name, updatedAt, synced, deleted, originalSynced, processedSynced',
      userGeometryFiles: '[id+kind]'
    })
    // v7: user-chart processed tiles archive (one ZIP blob per chart). Added
    // additively; prior tables are carried over by Dexie.
    this.version(7).stores({
      userChartTiles: 'id'
    })
    // v8: drop the user-chart tiles store. Tiles are no longer persisted; they
    // are prefetched into the in-memory store at boot (see
    // UserChartTilesPrefetchService), so they no longer need to survive a reload.
    // Setting the store to `null` deletes it (and reclaims the disk the ZIPs used)
    // on upgrade for existing users.
    this.version(8).stores({
      userChartTiles: null
    })
    // v9: durable outbox for a user chart's processed tiles archive (one ZIP blob
    // per pending chart). Added additively; prior tables are carried over by Dexie.
    this.version(9).stores({
      userChartOutbox: 'id'
    })
    // v10: drop the user-chart outbox. The planning-app is online-first and persists
    // nothing locally for charts — the pending upload now lives only in memory (see
    // userChartTilesOutbox). Setting the store to `null` deletes it on upgrade.
    this.version(10).stores({
      userChartOutbox: null
    })
  }
}
